/* ===================================================
   SHOPIFY 2.0 SAFE WISHLIST SYSTEM (STABLE VERSION)
=================================================== */

if (!window.__SHOPIFY_WISHLIST_SAFE__) {
  window.__SHOPIFY_WISHLIST_SAFE__ = true;

  const STORAGE_KEY = "shopify_wishlist";

  /* -------------------------
     STORAGE HELPERS
  ------------------------- */
  function getWishlist() {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
  }

  function saveWishlist(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    syncAllUI();
  }

  /* -------------------------
     TOGGLE WISHLIST
  ------------------------- */
  function toggleWishlist(handle) {
    let list = getWishlist();

    if (list.includes(handle)) {
      list = list.filter(h => h !== handle);
    } else {
      list.push(handle);
    }

    saveWishlist(list);
  }

  function isInWishlist(handle) {
    return getWishlist().includes(handle);
  }

  /* -------------------------
     BUTTON SYNC
  ------------------------- */
  function syncButtons() {
    document.querySelectorAll(".wishlist-btn").forEach((btn) => {
      const handle = btn.dataset.productHandle;
      if (!handle) return;

      if (isInWishlist(handle)) {
        btn.classList.add("added");
      } else {
        btn.classList.remove("added");
      }
    });
  }

  /* -------------------------
     COUNTER SYNC (SHOPIFY SAFE)
  ------------------------- */
  function syncCounter() {
    const count = getWishlist().length;

    // support multiple headers if theme has duplicates
    document.querySelectorAll("#wishlist-count, .wishlist-count").forEach((el) => {
      el.textContent = count;
    });
  }

  /* -------------------------
     GLOBAL SYNC
  ------------------------- */
  function syncAllUI() {
    syncButtons();
    syncCounter();
  }

  /* -------------------------
     CLICK HANDLER (EVENT DELEGATION)
  ------------------------- */
  document.addEventListener("click", (e) => {
    const btn = e.target.closest(".wishlist-btn");
    if (!btn) return;

    e.preventDefault();

    const handle = btn.dataset.productHandle;
    if (!handle) return;

    toggleWishlist(handle);
  });

  /* -------------------------
     SAFE INIT (SHOPIFY 2.0 READY)
  ------------------------- */
  function initWishlist() {
    syncAllUI();
  }

  // DOM ready
  document.addEventListener("DOMContentLoaded", initWishlist);

  // Shopify section reload safe hook
  window.addEventListener("load", initWishlist);

  /* -------------------------
     MULTI-TAB SYNC
  ------------------------- */
  window.addEventListener("storage", (e) => {
    if (e.key === STORAGE_KEY) {
      syncAllUI();
    }
  });
}